import React, { useState, useRef, useEffect } from "react";
import Chip from "../../Chip/Chip";
import Avatar from "../../Common/Avatar";
import Button from "../../Buttons/Button";

const userList = [
  {
    id: 1,
    name: "John Doe",
    email: "jonh@gmail.com",
  },
  {
    id: 2,
    name: "Jane Smith",
    email: "jane@gmail.com",
  },
  {
    id: 3,
    name: "Bob Johnson",
    email: "bob@gmail.com",
  },
];

const MailRecipient = ({ contactEmail, bccEmail, ccEmail ,getEmails}) => {
  const [inputValue, setInputValue] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [ccUsers, setCcUsers] = useState([]);
  const [bccUsers, setBccUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [activeField, setActiveField] = useState("to"); // "to", "cc", or "bcc"
  const [showCc, setShowCc] = useState(false);
  const [showBcc, setShowBcc] = useState(false);

  const toInputRef = useRef(null);
  const ccInputRef = useRef(null);
  const bccInputRef = useRef(null);
  const suggestionRef = useRef(null);

  // Filter users based on input
  useEffect(() => {
    if (inputValue.trim() === "") {
      setFilteredUsers([]);
      return;
    }

    const filtered = userList.filter(
      (user) =>
        user.name.toLowerCase().includes(inputValue.toLowerCase()) ||
        user.email.toLowerCase().includes(inputValue.toLowerCase())
    );
    setFilteredUsers(filtered);
  }, [inputValue]);
  console.log("contactEmail",contactEmail,bccEmail,ccEmail);
  console.log("bccUsers",bccUsers);
  console.log("ccUsers",ccUsers);
  console.log("selectedUsers",selectedUsers);
  const mapEmailList = (emailArray) => {
  return (emailArray || []).map((data, index) => ({
    name: data, // Assuming data is an email, but it's being used as a name too
    email: data, // Same issue here
    id: index + 1
  }));
};
useEffect(()=>{
  getEmails({selectedUsers, bccUsers, ccUsers});
},[selectedUsers, bccUsers, ccUsers])

useEffect(() => {
  // Handle contact email
  if (contactEmail) {
    const contactEmailList = mapEmailList(contactEmail);
    setSelectedUsers(contactEmailList.length > 0 ? contactEmailList : []);
  }

  // Handle BCC email
  if (bccEmail) {
    const bccEmailList = mapEmailList(bccEmail);
    setBccUsers(bccEmailList.length > 0 ? bccEmailList : []);
    setShowBcc(bccEmailList.length > 0); // Show BCC if there are emails
  }

  // Handle CC email
  if (ccEmail) {
    const ccEmailList = mapEmailList(ccEmail);
    setCcUsers(ccEmailList.length > 0 ? ccEmailList : []);
    setShowCc(ccEmailList.length > 0); // Show CC if there are emails
  }
}, [contactEmail, bccEmail, ccEmail]);

  // Handle click outside to close suggestions
  useEffect(() => {
    const handleClickOutside = (event) => {
      const currentInputRef =
        activeField === "to"
          ? toInputRef
          : activeField === "cc"
          ? ccInputRef
          : bccInputRef;

      if (
        suggestionRef.current &&
        !suggestionRef.current.contains(event.target) &&
        currentInputRef.current &&
        !currentInputRef.current.contains(event.target)
      ) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeField]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    setShowSuggestions(true);
  };

  // Check if email already exists in the specified recipient list
  const isEmailDuplicate = (email, field) => {
    let recipientList;
    if (field === "to") {
      recipientList = selectedUsers;
    } else if (field === "cc") {
      recipientList = ccUsers;
    } else if (field === "bcc") {
      recipientList = bccUsers;
    }

    return recipientList.some(
      (user) => user.email.toLowerCase() === email.toLowerCase()
    );
  };

  const handleSelectUser = (user) => {
    // Check if user's email already exists in the current field
    if (isEmailDuplicate(user.email, activeField)) {
      // Email already exists in this field, don't add it
      setInputValue("");
      setShowSuggestions(false);
      return;
    }

    // Add user to the appropriate list based on activeField
    if (activeField === "to") {
      setSelectedUsers([...selectedUsers, user]);
    } else if (activeField === "cc") {
      setCcUsers([...ccUsers, user]);
    } else if (activeField === "bcc") {
      setBccUsers([...bccUsers, user]);
    }

    setInputValue("");
    setShowSuggestions(false);

    // Focus the current active input
    if (activeField === "to" && toInputRef.current) {
      toInputRef.current.focus();
    } else if (activeField === "cc" && ccInputRef.current) {
      ccInputRef.current.focus();
    } else if (activeField === "bcc" && bccInputRef.current) {
      bccInputRef.current.focus();
    }
  };

  const handleCreateCustomChip = () => {
    if (inputValue.trim() === "") return;

    // Check if it's a valid email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(inputValue)) {
      // Check if email already exists in the current field
      if (isEmailDuplicate(inputValue, activeField)) {
        // Email already exists in this field, don't add it
        setInputValue("");
        setShowSuggestions(false);
        return;
      }

      const customUser = {
        id: `custom-${Date.now()}`,
        name: inputValue, // Use email as name if no name is available
        email: inputValue,
        isCustom: true,
      };

      // Add to the appropriate list based on activeField
      if (activeField === "to") {
        setSelectedUsers([...selectedUsers, customUser]);
      } else if (activeField === "cc") {
        setCcUsers([...ccUsers, customUser]);
      } else if (activeField === "bcc") {
        setBccUsers([...bccUsers, customUser]);
      }

      setInputValue("");
      setShowSuggestions(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (filteredUsers.length > 0) {
        handleSelectUser(filteredUsers[0]);
      } else {
        handleCreateCustomChip();
      }
    } else if (e.key === "," || e.key === ";") {
      e.preventDefault();
      handleCreateCustomChip();
    } else if (e.key === "Escape") {
      setShowSuggestions(false);
    } else if (e.key === "Backspace" && inputValue === "") {
      // Remove the last chip when backspace is pressed and input is empty
      if (activeField === "to" && selectedUsers.length > 0) {
        setSelectedUsers(selectedUsers.slice(0, -1));
      } else if (activeField === "cc" && ccUsers.length > 0) {
        setCcUsers(ccUsers.slice(0, -1));
      } else if (activeField === "bcc" && bccUsers.length > 0) {
        setBccUsers(bccUsers.slice(0, -1));
      }
    }
  };

  const handleDeleteChip = (userId, field) => {
    if (field === "to") {
      setSelectedUsers(selectedUsers.filter((user) => user.id !== userId));
    } else if (field === "cc") {
      setCcUsers(ccUsers.filter((user) => user.id !== userId));
    } else if (field === "bcc") {
      setBccUsers(bccUsers.filter((user) => user.id !== userId));
    }
  };

  const toggleCc = () => {
    setShowCc(true);
  };

  const toggleBcc = () => {
    setShowBcc(true);
  };

  const handleFieldFocus = (field) => {
    setActiveField(field);
  };

  return (
    <div className="relative w-full">
      {/* To Field */}
      <div className="flex flex-wrap items-center min-h-[40px] border-b-[1px] border-gray-300 gap-1.5 p-1">
        <span className="text-sm font-medium mr-1">To</span>
        {selectedUsers.map((user) => (
          <Chip
            key={user.id}
            label={user.name}
            onDelete={() => handleDeleteChip(user.id, "to")}
          />
        ))}
        <input
          ref={toInputRef}
          type="text"
          value={activeField === "to" ? inputValue : ""}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          onFocus={() => {
            handleFieldFocus("to");
            if (inputValue.trim() !== "") setShowSuggestions(true);
          }}
          placeholder={selectedUsers.length === 0 ? "Recipients" : ""}
          className="flex-1 min-w-[100px] border-none outline-none p-1 text-sm"
        />
        {!showCc && (
          <Button
            title={"CC"}
            variant="text"
            color="black"
            size="sm"
            onClick={toggleCc}
          />
        )}
        {!showBcc && (
          <Button
            title={"BCC"}
            variant="text"
            color="black"
            size="sm"
            onClick={toggleBcc}
          />
        )}
      </div>

      {/* CC Field */}
      {showCc && (
        <div className="flex flex-wrap items-center min-h-[40px] border-b-[1px] border-gray-300 gap-1.5 p-1">
          <span className="text-sm font-medium mr-1">Cc</span>
          {ccUsers.map((user) => (
            <Chip
              key={user.id}
              label={user.name}
              onDelete={() => handleDeleteChip(user.id, "cc")}
            />
          ))}
          <input
            ref={ccInputRef}
            type="text"
            value={activeField === "cc" ? inputValue : ""}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            onFocus={() => {
              handleFieldFocus("cc");
              if (inputValue.trim() !== "") setShowSuggestions(true);
            }}
            placeholder={ccUsers.length === 0 ? "Carbon copy recipients" : ""}
            className="flex-1 min-w-[100px] border-none outline-none p-1 text-sm"
          />
        </div>
      )}

      {/* BCC Field */}
      {showBcc && (
        <div className="flex flex-wrap items-center min-h-[40px] border-b-[1px] border-gray-300 gap-1.5 p-1">
          <span className="text-sm font-medium mr-1">Bcc</span>
          {bccUsers.map((user) => (
            <Chip
              key={user.id}
              label={user.name}
              onDelete={() => handleDeleteChip(user.id, "bcc")}
            />
          ))}
          <input
            ref={bccInputRef}
            type="text"
            value={activeField === "bcc" ? inputValue : ""}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            onFocus={() => {
              handleFieldFocus("bcc");
              if (inputValue.trim() !== "") setShowSuggestions(true);
            }}
            placeholder={
              bccUsers.length === 0 ? "Blind carbon copy recipients" : ""
            }
            className="flex-1 min-w-[100px] border-none outline-none p-1 text-sm"
          />
        </div>
      )}

      {/* Suggestions Dropdown */}
      {showSuggestions && filteredUsers.length > 0 && (
        <div
          className="absolute top-full left-0 w-full max-w-[350px] max-h-[200px] overflow-y-auto bg-white border border-gray-300 rounded-tl-none rounded-md z-10 -mt-[1px] shadow-md"
          ref={suggestionRef}
        >
          {filteredUsers.map((user) => (
            <div
              key={user.id}
              className="flex items-center p-2 cursor-pointer hover:bg-gray-100"
              onClick={() => handleSelectUser(user)}
            >
              <Avatar src={user.avatar} size="sm" className="mr-2.5" />
              <div className="flex flex-col">
                <div className="text-xs font-medium">{user.name}</div>
                <div className="text-xs text-gray-600">{user.email}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MailRecipient;
